import { useQuery } from '@apollo/client';

import GetThirdPartyOrganizationConfigurationPublicQuery from 'bundles/unified-common/queries/GetThirdPartyOrganizationConfigurationPublicQuery.graphql';
import type {
  GetThirdPartyOrganizationConfigurationPublicQueryQuery,
  GetThirdPartyOrganizationConfigurationPublicQueryQueryVariables,
} from 'bundles/unified-common/queries/__generated__/GetThirdPartyOrganizationConfigurationPublicQuery';

export const useSsoLockedOutStatus = (thirdPartyOrganizationId?: string) => {
  const { data, error, loading } = useQuery<
    GetThirdPartyOrganizationConfigurationPublicQueryQuery,
    GetThirdPartyOrganizationConfigurationPublicQueryQueryVariables
  >(GetThirdPartyOrganizationConfigurationPublicQuery, {
    variables: {
      organizationId: thirdPartyOrganizationId ?? '',
    },
    errorPolicy: 'all',
    context: { clientName: 'gatewayGql' },
    skip: !thirdPartyOrganizationId,
  });

  return {
    isSsoLockedOut: error ? false : data?.ThirdPartyOrganizationConfiguration?.isSsoLockedOutEnabled,
    isLoading: loading,
  };
};
